import { auth, provider } from "./firebase";
import { signInWithPopup } from "firebase/auth";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const navigate = useNavigate();

  const allowedUsers = [
    "mohtadiibtesum03@gmail.com",
    "maieshayusha@gmail.com",
    "sazidmostafiz2019@gmail.com",
  ];

  const handleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const email = result.user.email;

      if (allowedUsers.includes(email)) {
        navigate("/dashboard");
      } else {
        alert("Access denied. You are not an authorized user.");
        await auth.signOut();
      }
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  return (
    <div className="full-page">
      <div className="login-container login">
        <div className="login-box">
          <h2>Login to Dashboard</h2>
          <button onClick={handleLogin}>Login with Google</button>
        </div>
      </div>
    </div>
  );
}
